import { z } from 'zod';
import { NotificationPreferencesSchema, NotificationRolePolicySchema, } from '../app-notification';
import { BusinessActionEnumSchema, BusinessPaymentMethodV2Schema, BusinessProductAreaV2Schema, } from './shared/access-enums-v2';
export var DefaultBusinessRoleIdV2;
(function (DefaultBusinessRoleIdV2) {
    DefaultBusinessRoleIdV2["OWNER"] = "role_owner";
    DefaultBusinessRoleIdV2["MANAGER"] = "role_manager";
    DefaultBusinessRoleIdV2["CASHIER"] = "role_cashier";
    DefaultBusinessRoleIdV2["KITCHEN"] = "role_kitchen";
    DefaultBusinessRoleIdV2["READ_ONLY"] = "role_read_only";
})(DefaultBusinessRoleIdV2 || (DefaultBusinessRoleIdV2 = {}));
export const BusinessRoleGrantsV2Schema = z.object({
    productAreas: z.array(BusinessProductAreaV2Schema).default([]),
    actions: z.array(BusinessActionEnumSchema).default([]),
    paymentMethods: z.array(BusinessPaymentMethodV2Schema).default([]),
});
export const BusinessRoleLimitsV2Schema = z.object({
    /** Omit a limit when the role has no monetary refund ceiling. */
    maxRefundAmountCents: z.number().int().nonnegative().optional(),
    maxDiscountPercent: z.number().min(0).max(100).optional(),
    canRefundOwnTransactionsOnly: z.boolean().default(true),
});
export const BusinessRoleDefinitionV2Schema = z.object({
    id: z.string().min(1),
    name: z.string().min(1),
    description: z.string().min(1).optional(),
    grants: BusinessRoleGrantsV2Schema,
    limits: BusinessRoleLimitsV2Schema.default({
        canRefundOwnTransactionsOnly: true,
    }),
    /**
     * Notification delivery choices inherited by users assigned to this role.
     * Kept outside grants because notification delivery is not authorization.
     */
    notificationPreferences: NotificationPreferencesSchema.optional(),
    /**
     * Authorization ceiling for notification delivery, configuration, and
     * visibility. Optional on reads for legacy JSON compatibility; all current
     * mutation paths must resolve and persist an explicit policy.
     */
    notificationPolicy: NotificationRolePolicySchema.optional(),
});
